<div class="flex flex-row justify-content-between">
    <app-header label="database.usersPage.users" icon="pi-users"></app-header>
    <app-users-header-buttons
        [form]="sortingForm"
    ></app-users-header-buttons>
</div>

<div class="w-full">
    <app-users-filters
        [form]="filteringForm"
    ></app-users-filters>
</div>

<div class="mt-3 cardGrid w-full">
    @for (user of userScroll().items(); track user.id) {
        <app-user-card [user]="user"></app-user-card>
    }
</div>

<app-infinite-scroll-load-on-screen [infiniteScroll]="userScroll()"></app-infinite-scroll-load-on-screen>
